import React, { useEffect, useState } from 'react';
import { BsInstagram, BsWhatsapp } from 'react-icons/bs';

const apiUrl = process.env.REACT_APP_API_URL || '';

type SocialMediaProps = {
  size?: number;
  color?: string;
};

const WhatsappIcon = BsWhatsapp as React.FC<{ size?: number; color?: string }>;
const InstagramIcon = BsInstagram as React.FC<{ size?: number; color?: string }>;

const SocialMedia: React.FC<SocialMediaProps> = ({ size = 32 }) => {
  const [instagramUrl, setInstagramUrl] = useState<string>('');
  const [whatsappUrl, setWhatsappUrl] = useState<string>('');

  useEffect(() => {
    // Substitua pela URL real do seu endpoint
    fetch(`${apiUrl}/public/info`)
      .then(async (res) => {
        const resJson = await res.json();
        if (!res.ok) {
          console.error('Erro na resposta da API: ', resJson);
          return Promise.reject(resJson.message || 'Ocorreu um erro desconhecido.');
        }
        return resJson;
      })
      .then((data) => {
        const info: Info = data;
        const instagram = info['professionalInstagram'];
        const whatsapp = info['professionalPhone'].replace(/\D/g, '');

        setInstagramUrl(instagram ? `https://www.instagram.com/${instagram}` : '');
        setWhatsappUrl(whatsapp ? `https://wa.me/${whatsapp}` : '');
      })
      .catch((err) => {
        console.error('Erro ao carregar links sociais:', err);
        // alert('Erro ao carregar links sociais: ' + err);
      });
  }, []);

  return (
    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
      {instagramUrl && (
        <a href={instagramUrl} target="_blank" rel="noopener noreferrer">
          <InstagramIcon size={size} />
        </a>
      )}
      {whatsappUrl && (
        <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
          <WhatsappIcon size={size} />
        </a>
      )}
    </div>
  );
};

export default SocialMedia;
